var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 121,
    viewBox: "0 0 108 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6501 93.5586C34.9962 92.2436 37.1484 92.2739 38.4572 93.6263C43.4878 98.8241 51.1179 101.138 58.5288 99.0142C65.9397 96.8903 71.2063 90.8803 72.7503 83.7982C73.1521 81.9556 74.9645 80.7891 76.7984 81.1927C78.6324 81.5963 79.7935 83.4172 79.3917 85.2597C77.3337 94.6993 70.3057 102.742 60.3938 105.583C50.4818 108.424 40.288 105.316 33.5828 98.3881C32.274 97.0358 32.3041 94.8736 33.6501 93.5586Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.1292 5.92563L73.8163 20.7751L45.0685 0.5L24.1227 29.0622L0.451234 21.4783L13.8802 62.5668L13.8802 63.7109C6.23197 64.0362 -3.03641e-07 70.3752 0 78.1475C-1.99335e-07 86.1278 6.43232 92.5972 14.367 92.5971L15.4056 92.5965C20.2017 108.727 35.6907 120.5 54 120.5C72.3093 120.5 87.7983 108.727 92.5944 92.5964L94.1073 92.5894C101.822 92.3378 108 85.9682 108 78.1475L107.992 77.6705C107.747 70.0766 101.677 63.9638 94.1292 63.7062V5.92563ZM20.8697 63.1903L20.8073 82.0164C20.8073 99.1716 35.2822 113.191 53.3531 113.518L54 113.524C72.155 113.524 86.8434 99.7068 87.1865 82.6277L87.191 52.028L20.8697 63.1903ZM101.064 78.1475C101.064 82.1078 98.0016 85.3487 94.1284 85.6051V70.6898L94.8916 70.7802C98.3963 71.3816 101.064 74.4511 101.064 78.1475ZM13.487 70.7253L13.8716 70.6898V85.6051C9.99841 85.3487 6.93578 82.1078 6.93578 78.1475C6.93578 74.3191 9.79764 71.1631 13.487 70.7253Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo01);
export default __webpack_public_path__ + "static/media/logo01.611d042468e5a1ea7b7b36faddfb0153.svg";
export { ForwardRef as ReactComponent };